
define(
	'Convergence.GlobalExt.GlobalExt'
,   [
		'Header.MiniCart.View'
	,	'SiteSearch.View'
	,	'Header.View'
	,	'Backbone'
	// ,	'Backbone.View'
	// ,	'Utils'
	// ,	'underscore'
	// ,	'LiveOrder.Model'
	]
,   function (
		HeaderMiniCartView
	,	SiteSearchView
	,	HeaderView
	,	Backbone
	// ,	BackboneView
	// ,	Utils
	// ,	_
	// ,	LiveOrderModel
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			// _.extend(LiveOrderModel.prototype, {
			// 	getSubTotalProceCount:function getSubTotalProceCount() {
			// 		var summary = this.get('summary');
					
			// 		if (summary && summary.subtotal) {
						
			// 			return summary.subtotal;
			// 		}
			// 		return 0;
			// 	}
			// });
			// _.extend(HeaderMiniCartView.prototype, {
			// 	initialize: _.wrap(HeaderMiniCartView.prototype.initialize, function initialize(fn) {
			// 		fn.apply(this, _.toArray(arguments).slice(1));
			// 		this.priceCount = 0;
			// 	}),
			// 	render: function render() {
			// 		this.itemsInCart = this.model.getTotalItemCount();
					
			// 		this.priceCount = this.model.getSubTotalProceCount();
			// 		BackboneView.prototype.render.apply(this, arguments);
			
			// 		// on tablet or desktop make the minicart dropdown
			// 		if (
			// 			Utils.isTabletDevice() ||
			// 			Utils.isDesktopDevice() ||
			// 			SC.CONFIGURATION.addToCartBehavior === 'showMiniCart'
			// 		) {
			// 			this.$('[data-type="mini-cart"]').attr('data-toggle', 'dropdown');
			// 		}
			// 	},
			// 	getContext: _.wrap(HeaderMiniCartView.prototype.getContext, function getContext(fn) {
			// 		var context = fn.apply(this, _.toArray(arguments).slice(1));
			// 		context.priceCount =  this.priceCount;
					
			// 		return context;
			// 	})
			// });

			_.extend(HeaderView.prototype, {
				initialize: _.wrap(HeaderView.prototype.initialize, function initialize(fn) {
					fn.apply(this, _.toArray(arguments).slice(1)); 
					this._setupSearch();
					$(window).on('resize', _.bind(this._setupSearch, this));
					Backbone.history.on('route', this.changeSearch,this);
					
					
				}),
				changeSearch: function () {
					let hash_item = (Backbone.history.getFragment() || '').split('?')[0];
					var documentData = document.querySelector('#site-header-setting');
					if(documentData.classList.contains('header-custom-class')){
						documentData.classList.remove('header-custom-class')					
					}
					if(hash_item === ''){
						documentData.classList.remove('header-custom-class');
					}else{						

						documentData.classList.add('header-custom-class');
						
					}

					
				},
				getContext: _.wrap(HeaderView.prototype.getContext, function getContext(fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					let hash_item = (Backbone.history.getFragment() || '').split('?')[0];
					
					var isHomePage = true;
					if(hash_item === ''){
						
						isHomePage = false;
					}
					context.isHomePage = isHomePage;
					
					return context;
				}),
				_setupSearch: function () {
					var self = this;
					if (this._currentSearchView) {
						layout.removeChildView('SiteSearches');
					}
					
					if (window.innerWidth >= 992) {
						this._currentSearchView =  new SiteSearchView({
							el: this.$('.header-search-desktop-view'),
							application: this.application
						});
						layout.addChildView('SiteSearches',function(){
							return new SiteSearchView({
								el: self.$('.header-search-desktop-view'),
								application: self.application
							}) 
						});
						this.$('.header-search-mobile-view').empty();
					} else {
						this._currentSearchView = new SiteSearchView({
							el: this.$('.header-search-mobile-view'),
							application: this.application
						});
						layout.addChildView('SiteSearches',function(){
							return new SiteSearchView({
								el: self.$('.header-search-mobile-view'),
								application: self.application
							}) 
						});
						this.$('.header-search-desktop-view').empty();
					}
				},
				
			})
			// _.extend(SiteSearchView.prototype, {

			// })

		}
	};
});
